/**
 * PendingInvites — list of outstanding external invites with status,
 * delivery mode (federated vs magic link), and invite expiry.
 */
import React from 'react';

function formatDate(d) {
  if (!d) return '—';
  return new Date(d).toISOString().slice(0, 16).replace('T', ' ');
}

export default function PendingInvites({ invites }) {
  const sorted = [...(invites || [])].sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
  return (
    <div style={{ background: '#ffffff', border: '1px solid #e2e8f0', borderRadius: 10, overflow: 'hidden' }}>
      <div style={{
        display: 'grid',
        gridTemplateColumns: '1.4fr 1fr 1fr 1.4fr 0.8fr 0.8fr',
        gap: 16, padding: '10px 18px',
        background: '#fafbfc', borderBottom: '1px solid #e2e8f0',
        fontSize: 10.5, letterSpacing: '0.08em', textTransform: 'uppercase',
        color: '#94a3b8', fontFamily: 'ui-monospace, monospace',
      }}>
        <div>Invitee</div>
        <div>Title</div>
        <div>Apps</div>
        <div>Delivery</div>
        <div>Status</div>
        <div style={{ textAlign: 'right' }}>Invite expires</div>
      </div>
      {sorted.length === 0 && (
        <div style={{ padding: '24px', color: '#94a3b8', fontSize: 13 }}>
          No pending invites.
        </div>
      )}
      {sorted.map(i => (
        <div
          key={i.id}
          style={{
            display: 'grid',
            gridTemplateColumns: '1.4fr 1fr 1fr 1.4fr 0.8fr 0.8fr',
            gap: 16, padding: '14px 18px',
            borderTop: '1px solid #f1f5f9',
          }}
        >
          <div>
            <div style={{ fontSize: 13, color: '#0f172a', fontWeight: 500 }}>{i.name || '(no name)'}</div>
            <div style={{ fontSize: 11, color: '#64748b', fontFamily: 'ui-monospace, monospace', marginTop: 2 }}>{i.email}</div>
          </div>
          <div style={{ fontSize: 13, color: '#0f172a' }}>{i.title || '—'}</div>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
            {(i.app_keys || []).map(k => (
              <span key={k} style={{
                fontSize: 11, padding: '2px 8px',
                background: '#f1f5f9', color: '#475569',
                border: '1px solid #e2e8f0', borderRadius: 999,
                fontFamily: 'ui-monospace, monospace',
              }}>{k}</span>
            ))}
          </div>
          <div style={{ fontSize: 12, color: '#475569' }}>
            {i.delivery_mode === 'federated' ? 'Azure AD (federated)' : 'Magic link (email)'}
          </div>
          <div>
            <span style={{
              fontSize: 11, padding: '2px 8px', borderRadius: 999, fontFamily: 'ui-monospace, monospace',
              background: i.status === 'pending' ? '#fffbeb' : i.status === 'accepted' ? '#ecfdf5' : '#f1f5f9',
              color:      i.status === 'pending' ? '#92400e' : i.status === 'accepted' ? '#065f46' : '#475569',
              border: `1px solid ${i.status === 'pending' ? '#fde68a' : i.status === 'accepted' ? '#a7f3d0' : '#cbd5e1'}`,
            }}>
              {i.status}
            </span>
          </div>
          <div style={{ fontSize: 11, color: '#94a3b8', textAlign: 'right', fontFamily: 'ui-monospace, monospace' }}>
            {formatDate(i.invite_expires_at)}
          </div>
        </div>
      ))}
    </div>
  );
}
